import { useQuery } from '@tanstack/react-query';
import { School } from '../models';
import QueryKeys from '../utils/QueryKeys';

/**
 * The backdrop a school's senior portraits are printed on (schools.senior_background,
 * e.g. "Senior_Blue" -> the Senior/Blue background). Returns its image URL, or null when
 * the school has none configured — callers fall back to the package background so a
 * missing setting can never blank a pose.
 *
 * senior_background_url is an extra_attribute (see Api::SchoolResource), so it must be
 * opted into with selectExtra; a plain School.find() will not carry it.
 */
export default function useSeniorBackground(schoolId) {
  return useQuery(
    [QueryKeys.SENIOR_BACKGROUND, schoolId],
    () => School
      .selectExtra(['senior_background_url'])
      .find(schoolId)
      .then((res) => res.data.seniorBackgroundUrl || null),
    { enabled: !!schoolId, staleTime: Infinity, placeholderData: null },
  );
}
